import { useState, useEffect } from "react";
import useHandleWindowResize from "../../../common/useHandleWindowResize.js";
import { navItemShape } from "../PrimaryNav/primaryNavTypes.js";
import MobileMenuContextLabelButton from "../MobileMenu/MobileMenuContextLabelButton.jsx";
import LinkGroup from "./LinkGroup.jsx";
import cx from "classnames";
import { func, string, bool, object } from "prop-types";

const propTypes = {
  item: navItemShape.isRequired,
  returnToPreviousScreen: func,
  isMegaMenuOpen: bool,
  parentClasses: string,
  menuItemDimensions: object,
  style: object,
};

const FeaturedContentMegaMenu = (props) => {
  const [grandchildMenuOpen, setGrandchildMenuOpen] = useState("");
  const {
    item,
    returnToPreviousScreen,
    isMegaMenuOpen,
    parentClasses,
    menuItemDimensions,
    style,
  } = props;

  // See \frontend\EGH\scss\_breakpoints.scss
  const breakpointLarge = 910; // $bp-large
  const breakpointLargeMax = breakpointLarge - 1; // $bp-x-large-max

  const { isDesktop } = useHandleWindowResize({
    breakpoint: breakpointLargeMax,
  });

  useEffect(() => {
    if (!isMegaMenuOpen) {
      setGrandchildMenuOpen("");
    }
  }, [isMegaMenuOpen, setGrandchildMenuOpen]);

  return (
    <div
      className={cx(parentClasses, {
        "featured-content__dropdown--grandchild-open": grandchildMenuOpen,
      })}
      style={style}
    >
      <MobileMenuContextLabelButton
        returnToPreviousScreen={returnToPreviousScreen}
        label={item.title}
      />
      <div className="featured-content__dropdown-container">
        {/* link group */}
        <div
          className={cx("featured-content__link-list-container", {
            "featured-content__link-list-container--child-open": grandchildMenuOpen,
          })}
        >
          <ul className="featured-content__link-list">
            {item.children.map((group, i) => {
              return (
                <li key={i} className="featured-content__link-list-item">
                  <div className="featured-content__link-list-label">
                    {group.label}
                  </div>
                  {group.children && group.children.length && (
                    <ul>
                      {group.children.map((item, j) => {
                        return (
                          <LinkGroup
                            key={j}
                            item={item}
                            granchildMenuOpenLabel={grandchildMenuOpen}
                            setGrandchildMenuOpenLabel={setGrandchildMenuOpen}
                            isDesktop={isDesktop}
                            menuItemDimensions={menuItemDimensions}
                          />
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        {/* featured content */}
        <div className="featured-content__container">
          <h2 className="featured-content__title">{item.featuredTitle}</h2>
          <ul className="featured-content__list">
            {item.featuredLinks &&
              item.featuredLinks.length &&
              item.featuredLinks.map((group, i) => {
                return (
                  <li key={i} className="featured-content__list-item">
                    {/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                    <a
                      className={cx("featured-content__card", {
                        "disabled-link": grandchildMenuOpen,
                      })}
                      {...(grandchildMenuOpen
                        ? { href: "//:0", tabIndex: -1 }
                        : { href: group.href })}
                    >
                      <p className="featured-content__card-topic">
                        {group.topic}
                      </p>
                      <h3 className="featured-content__card-title">
                        {group.title}
                      </h3>
                      <p className="featured-content__card-subtitle">
                        {group.subtitle}
                      </p>
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

FeaturedContentMegaMenu.propTypes = propTypes;
export default FeaturedContentMegaMenu;
